import {
  NotificationApiRequest,
  UpdateNotificationRequest,
} from '@/data/payload/api/NotificationRequest'
import {
  PostNotificationInterface,
  DeleteNotificationInterface,
  UpdateNotificationInterface,
} from '@/data/payload/contracts/NotificationRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { NotificationDataMapper } from '@/data/persistences/mappers/NotificationDataMapper'
import { NotificationRepositoryInterface } from '@/data/persistences/repositories/contracts/NotificationRepositoryInterface'
import { Notification } from '@/domain/entities/Notification'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class NotificationApiRepository
  implements NotificationRepositoryInterface {
  private service: ApiService
  private mapper: NotificationDataMapper

  constructor(service: ApiService, mapper: NotificationDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(
    payload: DeleteNotificationInterface
  ): Promise<Notification> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.NOTIFICATION_DELETE,
      undefined,
      payload as NotificationApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(payload: PostNotificationInterface): Promise<Notification> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.NOTIFICATION,
      undefined,
      payload as NotificationApiRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateNotificationInterface,
    id: number
  ): Promise<Notification> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.NOTIFICATION}/${id}`,
      undefined,
      payload as UpdateNotificationRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<Notification> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.NOTIFICATION,
      params
    )
    return this.mapper.convertNotificationFromApi(resp)
  }
}
